module.exports = __webpack_public_path__ + "img/i_15_h.8f0d5772.png";